<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome da criança"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :item-class="getRowColor"
          :items="indexedItems"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>
          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>
          <template v-slot:header.cfcp="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Número identificador do cidadão no e-SUS. Na falta dessa informação, atualizar o cadastro FCI ou Cidadão."
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>
          <template v-slot:item.cfcp="{ item }">
            <div v-if="item.cfcp == null">
              <i class="icofont-warning"></i>
            </div>
            <div v-else>
              {{ item.cfcp }}
            </div>
          </template>
          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }}

            ({{
              item.idade_meses == 1
                ? `${item.idade_meses} mês`
                : `${item.idade_meses} meses`
            }})
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="7">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>
                      Cadastrado por
                      <span
                        v-b-tooltip.hover
                        title="CPF do profissional que atualizou o cadastro do cidadão."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{ item.nu_cpf }}
                    </td>
                    <td>
                      {{ item.nu_cns }}
                    </td>
                    <td>
                      {{ item.no_profissional }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>
                      PNEUMO 10V (D2) <br />
                      <div style="font-weight: normal">4 meses</div>
                    </th>
                    <th>
                      ROTA VÍRUS (D2) <br />
                      <div style="font-weight: normal">4 meses</div>
                    </th>
                    <th>
                      MENINGO C (D2) <br />
                      <div style="font-weight: normal">5 meses</div>
                    </th>
                    <th>
                      PENTA (D3) <br />
                      <div style="font-weight: normal">6 meses</div>
                    </th>
                    <th>
                      VIP (D3)<br />
                      <div style="font-weight: normal">6 meses</div>
                    </th>
                    <th>
                      F. AMARELA (D)<br />
                      <div style="font-weight: normal">9 meses</div>
                    </th>
                    <th>
                      T. VIRAL (D1)<br />
                      <div style="font-weight: normal">12 meses</div>
                    </th>
                    <th>
                      HEPATITE A (DU)<br />
                      <div style="font-weight: normal">15 meses</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <item-doses
                        :item="item"
                        :dose="item.dosePneumococica"
                        :dosePendente="item.dosePneumococicaPendente"
                        :meses="4"
                      ></item-doses>
                    </td>
                    <td>
                      <item-doses
                        :item="item"
                        :dose="item.doseRotaVirus"
                        :dosePendente="item.doseRotaVirusPendente"
                        :meses="4"
                      ></item-doses>
                    </td>
                    <td>
                      <item-doses
                        :item="item"
                        :dose="item.doseMeningococicaC"
                        :dosePendente="item.doseMeningococicaCPendente"
                        :meses="5"
                      ></item-doses>
                    </td>
                    <td>
                      <item-doses
                        :item="item"
                        :dose="item.dosePenta"
                        :dosePendente="item.dosePentaPendente"
                        :meses="6"
                      ></item-doses>
                    </td>
                    <td>
                      <item-doses
                        :item="item"
                        :dose="item.doseVip"
                        :dosePendente="item.doseVipPendente"
                        :meses="6"
                      ></item-doses>
                    </td>
                    <td>
                      <item-doses
                        :item="item"
                        :dose="item.doseFebreAmarela"
                        :dosePendente="item.doseFebreAmarelaPendente"
                        :meses="9"
                      ></item-doses>
                    </td>
                    <td>
                      <item-doses
                        :item="item"
                        :dose="item.doseTripliceViral"
                        :dosePendente="item.doseTripliceViralPendente"
                        :meses="12"
                      ></item-doses>
                    </td>
                    <td>
                      <item-doses
                        :item="item"
                        :dose="item.doseHepatiteA"
                        :dosePendente="item.doseHepatiteAPendente"
                        :meses="15"
                      ></item-doses>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import * as Functions from './functions'
import utils from '@/mixins/utils.js'
import ItemDoses from './ItemDoses.vue'

export default {
  name: 'TabelaCadastros',
  components: {
    ItemDoses,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'MA',
          align: 'start',
          filterable: false,
          value: 'micro_area',
        },

        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  computed: {
    indexedItems() {
      return Functions.formatarCadastrosComDoses(this.cadastros)
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object}
     *
     * @returns {String}
     */
    getRowColor(item) {
      return 'table-row-color-' + item.cor
    },
  },
}
</script>

<style scoped lang="scss"></style>
